import { type FC } from 'react';
import {
  type UiBoxProps
} from '@/lib/ui';
import BaseAppRegistrationCard from '@/base/App/RegistrationCard';
import ModuleCard, { type ModuleCardProps } from './ModuleCard';

export interface RegistrationProps extends Omit<ModuleCardProps, 'children'> {
}

const Registration: FC<RegistrationProps> = ({
  ...props
}) => {
  return (
    <ModuleCard
      {...props}
    >
      <BaseAppRegistrationCard />
    </ModuleCard>
  );
};

export default Registration;
